import axios from "axios";
import { LOGIN, MAINTENANCE } from "@routes/routes";
import { API_BASE_URL, API_URL } from "@config/app";
import { isClientPanelHostname } from "@hooks/useClientPanel";
import { isRetryableResponse } from "@utils/idempotency";
import { isPublicIdempotentMutation } from "@utils/publicIdempotentRequest";
import { isStoreWebSessionExpiredFailure } from "@utils/storeWebSessionFailure";

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.interceptors.response.use(
  response => response,
  async error => {
    const status = error?.response?.status;
    const originalRequest = error.config;

    if (status === 401) {
      if (!isStoreWebSessionExpiredFailure(error) && !isClientPanelHostname()) {
        window.location.href = LOGIN;
      }
      return Promise.reject(error);
    }

    if (status === 419 && !originalRequest._retry) {
      originalRequest._retry = true;
      await axios.get(`${API_URL}/csrf-cookie`);
      return axios(originalRequest);
    }

    if (
      status === 503 &&
      !isRetryableResponse(status, error?.response?.data) &&
      !isPublicIdempotentMutation(originalRequest) &&
      window.location.pathname !== MAINTENANCE
    ) {
      window.location.href = MAINTENANCE;
    }

    return Promise.reject(error);
  },
);

export default axios;
